import { render, staticRenderFns } from "./MemberViewEdit.vue?vue&type=template&id=087438f4&"
import script from "./MemberViewEdit.vue?vue&type=script&lang=js&"
export * from "./MemberViewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports